import type { WebWidgetModel } from '@web/types';

import { Widgets } from '@common/enums';
import { defaultWidgetPermission, defaultWidgetParams } from '@common/constants';

import { createLine } from '@sites/entity-core';

import { LineViewComponent } from '@web/widgets/line/components/line-view/line-view.component';
import { LineControlComponent } from '@web/widgets/line/components/line-control/line-control.component';

/**
 * The divider is a versioned widget: `createEntity` seeds a new one, and its
 * presence makes the editor lift persisted legacy lines on load. There is
 * no legacy `data` / `styles` seed any more — everything lives in the entity's `props`.
 */
export const lineWidgetModel: WebWidgetModel = {
    componentView: LineViewComponent,
    componentControl: LineControlComponent,
    name: Widgets.LINE,
    label: 'widget_divider_label',
    data: undefined,
    permission: defaultWidgetPermission,
    params: defaultWidgetParams,
    signalForm: true,
    createEntity: createLine,
};
